import Settings from './Settings';

export { Settings };



// WEBPACK FOOTER //
// src/modules/screens/settings/main/components/index.js